import {EventGateway} from "./event-gateway";
import {HandlerOptions} from "./handler";

export function HandleEvent(name?: string, options?: HandlerOptions): MethodDecorator {
  return (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor => {
    EventGateway.registerHandlerInvoker(target.constructor.name, name || String(propertyKey), descriptor.value, options);
    return descriptor;
  }
}
